import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Environment, EnvConfig } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';
import { OrganizationGetListRequest, OrganizationGetListResponse, BaseResponse, OrganizationDeleteRequest, OrganizationInsertRequest } from '../models';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
    private http: HttpClient
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getAllOrganizations(body: any) {
    const link = this.apiUrl + ApiUrls.getAllOrganizations;
    return this.http.post<OrganizationGetListResponse>(link, body);
  }

  deleteOrganization(body: OrganizationDeleteRequest) {
    const link = this.apiUrl + ApiUrls.deleteOrganization;
    return this.http.post<BaseResponse>(link, body);
  }

  insertOrganization(body: OrganizationInsertRequest) {
    const link = this.apiUrl + ApiUrls.insertOrganization;
    return this.http.post<BaseResponse>(link, body);
  }

  getOrganizationDetail(id: number) {
    const link = this.apiUrl + ApiUrls.getAllOrganizationsDetails+"/"+id;
    return this.http.get<BaseResponse>(link);
  }

  updateOrganization(body:OrganizationInsertRequest){
    const link = this.apiUrl + ApiUrls.updateOrganization;
    return this.http.post<BaseResponse>(link, body);
  }

}
